/** @jsx jsx */
import { jsx } from 'theme-ui';
import View from '../View/View';

export default function Col({ flex, ...rest }) {
  return (
    <View
      sx={{
        paddingX: 'columnGap',
        boxSizing: 'border-box',
        flex: flex === true ? '1' : flex,
      }}
      {...rest}
    />
  );
}
